export default __webpack_public_path__ + "static/media/okex.233e80d7.webp";